<template>
  <section class="tablist">
    <section class="list_item border-bottom" @click="toMyorder">
      <img class="left_icon" :src="require(`../../../assets/images/icon_my_order_${$store.state.common.theme}.png`)" />
      <span>我的订单</span>
      <img class="right_icon" src="../../../assets/images/icon_indicator_next.png" />
    </section>
    <section class="list_item border-bottom" @click="toCoupon">
      <img class="left_icon" :src="require(`../../../assets/images/icon_my_coupon_${$store.state.common.theme}.png`)" />
      <span class="repair">我的卡券</span>
      <img class="right_icon" src="../../../assets/images/icon_indicator_next.png" />
    </section>
    <section class="list_item border-bottom" @click="toProper">
      <img class="left_icon" :src="require(`../../../assets/images/icon_my_repairs_${$store.state.common.theme}.png`)" />
      <span class="repair">我的报修</span>
      <img class="right_icon" src="../../../assets/images/icon_indicator_next.png" />
    </section>
    <!-- <section class="list_item border-bottom" @click="toSuggest">
      <img class="left_icon" :src="require(`../../../assets/images/icon_my_suggest_${$store.state.common.theme}.png`)" />
      <span class="repair">投诉建议</span>
      <img class="right_icon" src="../../../assets/images/icon_indicator_next.png" />
    </section> -->
     <section class="list_item border-bottom" @click="toIntegralMall">
      <img class="left_icon" :src="require(`../../../assets/images/icon_my_intergal_0.png`)" />
      <span class="repair">积分商城</span>
      <img class="right_icon" src="../../../assets/images/icon_indicator_next.png" />
    </section>
    <section class="list_item border-bottom" @click="toVerifiyTradeRecord">
      <img class="left_icon" :src="require(`../../../assets/images/icon_my_VerifiyTrade_0.png`)" />
      <span class="repair">商户核销</span>
      <img class="right_icon" src="../../../assets/images/icon_indicator_next.png" />
    </section>
    <section class="list_item border-bottom" @click="toInvoice">
      <img class="left_icon" :src="require(`../../../assets/images/icon_my_invoice_${$store.state.common.theme}.png`)" />
      <span class="repair">开具发票</span>
      <img class="right_icon" src="../../../assets/images/icon_indicator_next.png" />
    </section>
    <section class="list_item border-bottom" @click="toSetting">
      <img class="left_icon" :src="require(`../../../assets/images/icon_my_settings_${$store.state.common.theme}.png`)" />
      <span class="setting">设置</span>
      <img class="right_icon" src="../../../assets/images/icon_indicator_next.png" />
    </section>
    <privacy-tip ref='privacyTip'></privacy-tip>
  </section>
</template>

<script>
import {checkInvoice} from '../../../utils/api';
import privacyTip from './privacy-tip.vue'
import util from '../../../utils/util';
export default {
  name:'myTabList',
  components:{
    privacyTip
  },
  methods:{
    toIntegralMall(){
      if(this.$store.state.common.userInfo.pointAgree == 0){
         this.$refs.privacyTip.openDialog()
      }else{
         this.$router.push({
            path:'/IntegralMall'
         })
      }
    },

    toVerifiyTradeRecord(){
      if (!this.$store.state.common.userId) {
        this.$router.push({
          path: '/login',
          query: {
            Rurl: '/VerifiyTradeRecord'
          }
        })
      } else {
        this.$router.push({
          path: '/VerifiyTradeRecord'
        })
      }
    },
    toMyorder(){
      if (!this.$store.state.common.userId) {
        this.$router.push({
          path: '/login',
          query: {
            Rurl: '/myOrder'
          }
        })
      } else {
        this.$router.push({
          path: '/myOrder'
        })
      }
    },
    toSetting(){

      this.$router.push({
         // path:'/IntegralMall'
          path:`me/Setting?settingType=1`
        })
    },
    toSuggest(){
      if (!this.$store.state.common.userId) {
        this.$router.push({
          path: '/login',
          query: {
            Rurl: '/myComplaintOrder'
          }
        })
      } else {
        this.$router.push({
          path: '/myComplaintOrder'
        })
      }
    },
    toInvoice(){

      if (!this.$store.state.common.userId) {
        this.$router.push({
          path: '/login',
        })
      } else {
         this.$router.push({
             path: '/InvoicIndex'
         })
          //  let params = {
          //   marketId:this.$store.state.common.marketInfo.id,
          //   userId:this.$store.state.common.userId
          // };
          // util.showLoading("加载中...");
          // checkInvoice(params).then(res => {
          //   console.log(res);
          //   util.hideLoading();
          //   var isOpen  =false;
          //   if(res.res.code ==10000 && res.body){
          //      isOpen = res.body.isOpen;
          //   }
          //   if(isOpen){
          //       this.$router.push({
          //        path: '/InvoicIndex'
          //       })
          //   }else{
          //      util.showToast("该项目尚未开通电子发票，如需开票请联系物业运营人员");
          //   }

          //});
      }

    },

    toProper(){
      if (!this.$store.state.common.userId) {
        this.$router.push({
          path: '/login',
          query: {
            Rurl: '/myRepairOrder'
          }
        })
      } else {
        this.$router.push({
          path: '/myRepairOrder'
        })
      }
    },
    toCoupon(){
      if (!this.$store.state.common.userId) {
        this.$router.push({
          path: '/login',
          query: {
            Rurl: '/myCoupon'
          }
        })
      } else {
        this.$router.push({
          path: '/myCoupon'
        })
      }

    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../../assets/css/common.less");
.tablist {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0.04rem 0.24rem 0px rgba(0, 0, 0, 0.08);
  border-radius: 0.08rem;
  padding-left:32px;
  margin:28px 28px 120px;
  position: relative;
  z-index:2;
}
.list_item{
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items: center;
  height:120px;
  span{
    height:120px;
    line-height:120px;
    display: block;
    font-size:32px;
    color:rgba(51,51,51,1);
    flex:1;
    text-align: left;
  }
  .left_icon{
    display: block;
    width:44px;height:44px;
    margin-right:20px;
  }
  .right_icon{
    display: block;
    width:32px;
    height:32px;
    padding-right:32px;
  }
}

</style>
